<template>
    <b-card>
        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="col-12 mt-16">
            <div>
                <b-row class="align-items-center">
                    <b-col lg="6" class="my-1">
                        <b-form-group label="" label-for="filter-input" label-cols-sm="1" label-align-sm="right"
                            label-size="sm" class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="filter-input" v-model="filter" type="search"
                                    placeholder="Type to Search"></b-form-input>
                                <b-input-group-append>
                                    <b-button @click="applyFilter" :disabled="!filter"
                                        variant="primary">Apply</b-button>
                                <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" class="my-1 d-flex justify-content-end">
                        <b-button @click="toggleReorder" :variant="reorderMode ? 'warning' : 'info'" class="mb-8 mr-8">
                            {{ reorderMode ? 'Cancel Reorder' : 'Reorder' }}
                        </b-button>
                        <b-button v-if="reorderMode" @click="saveOrder" variant="success" class="mb-8 mr-8" :disabled="savingOrder">
                            <span v-if="!savingOrder">Save Order</span>
                            <b-spinner v-else small></b-spinner>
                        </b-button>
                        <b-button @click="exportAllDataToCSV" variant="primary" class="mb-8 mr-8">Export</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-row>
            <div class="col-12 mt-16">
                <b-skeleton-table
                    v-if="loading"
                    :rows="perPage"
                    :columns="fields.length"
                    animation="wave"
                    bordered
                    class="mb-3"
                    />

                <!-- Reorder Mode -->
                <div v-else-if="reorderMode">
                    <p class="text-muted mb-2">Drag rows to reorder. Click "Save Order" when done.</p>
                    <draggable v-model="reorderList" handle=".drag-handle" @end="onDragEnd" tag="div">
                        <div v-for="(item, index) in reorderList" :key="item.id" class="reorder-row d-flex align-items-center p-2 mb-1 border rounded">
                            <span class="drag-handle mr-3" style="cursor: grab; font-size: 20px;">&#x2630;</span>
                            <span class="mr-3 font-weight-bold">{{ index + 1 }}.</span>
                            <img v-if="item.image" :src="'https://wossdb.wossautoid.com/' + item.image" alt="" width="40" height="40" class="mr-3 rounded" />
                            <span>{{ item.name || 'N/A' }}</span>
                            <span v-if="item.category" class="ml-2 text-muted">- {{ item.category.title }}</span>
                        </div>
                    </draggable>
                </div>

                <!-- Normal table -->
                <b-table v-else id="dataTable" :items="users" :busy.sync="loading" :fields="fields" :current-page="currentPage"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty responsive striped hover  class="custom-zebra">
                     <template #cell(position)="row">
                        {{ (row.item.position ?? 0) + 1 }}
                    </template>
                     <template #cell(name)="row">
                        {{ row.item.name ||'N/A' }}
                    </template>

                    <template #cell(actions)="row">
                        <b-button v-b-tooltip.hover title="Show Brand" @click="showDrivers(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" style="
                color: rgba(0, 255, 195, 0.87);
                margin-left: 6px;
                margin-bottom: 10px;
              " class="bi bi-eye" viewBox="0 0 16 16">
                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                            </svg>
                        </b-button>
                        <b-button v-b-tooltip.hover title="Delete Brand" @click="showDeleteConfirmation(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                style="color: red; margin-left: 6px; margin-bottom: 10px" class="bi bi-eye"
                                viewBox="0 0 16 16">
                                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                        </b-button>
                        <b-modal v-model="showDeleteConfirmations" title="Delete Confirmation">
                            <p>Are you sure you want to delete this item?</p>
                            <template #modal-footer>
                                <b-button variant="primary" @click="deleteItem(itemIdToDelete)">Delete</b-button>
                                <b-button variant="primary" @click="showDeleteConfirmations = false">Cancel</b-button>
                            </template>
                        </b-modal>

                        <b-button v-b-tooltip.hover title="Edit Brand" @click="editUser(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                style="color: orange; margin-left: 10px; margin-bottom: 10px" class="bi bi-pencil"
                                viewBox="0 0 16 16">
                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                            </svg>
                        </b-button>
                    </template>
                    <template #cell(image)="row">
                        <div>
                        <img v-if="row.item.image" :src="'https://wossdb.wossautoid.com/' + row.item.image" alt="Picture" width="100"
                        height="100" />
                        <span v-else>N/A</span>
                        </div>     
                    </template>

                    <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3" label-align-sm="right"
                        label-size="sm" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter" type="search"
                                placeholder="Type to Search"></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-table>
                <div v-if="!reorderMode" class="mx-8 d-flex justify-content-end">
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage"
                        aria-controls="dataTable" @change="pageChanged"></b-pagination>
                </div>
                <b-row class="mt-16 align-items-center justify-content-end">
                    <b-row>
                    </b-row>
                </b-row>
            </div>
        </b-row>
    </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BButton, BTable, BFormGroup, BInputGroup,
    BFormInput, BFormSelect, BPagination, BInputGroupAppend,
    BSpinner, BSkeleton, BSkeletonTable,
} from "bootstrap-vue";
import axios from "../../../axios";
import Papa from "papaparse";
import draggable from "vuedraggable";

export default {
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            lastPage: 0,
            firstPageUrl: null,
            lastPageUrl: null,
            nextPageUrl: null,
            prevPageUrl: null,
            isLoading: false,
            users: [],
            fields: [
                { key: "id", sortable: true },
                { key: "position", label: "Position", sortable: true },
                { key: "name", sortable: true },
                { key: "category.title", label: "Category Name" },
                { key: "image", sortable: true },
                { key: "actions", label: "Actions" },
            ],
            filter: "",
            total: 0, 
            showDeleteConfirmations: false,
            itemIdToDelete: null,
            loading: false,
            image: "",
            reorderMode: false,
            reorderList: [],
            savingOrder: false,
        };
    },
    components: {
        BRow, BCol, BCard, BButton, BTable, BFormGroup, BInputGroup,
        BFormInput, BFormSelect, BPagination, BInputGroupAppend,
        BSpinner, BSkeleton, BSkeletonTable, draggable,
    },
    computed: {
        sortOptions() {
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => ({ text: f.label, value: f.key }));
        },
        rows() {
            return this.users.length;
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        clearFilter() {
            this.filter = '';
            this.currentPage = 1;
            this.fetchData();
        },
        async fetchData() {
            this.loading = true;
            try {
                const response = await axios.get("brand", {
                    params: { page: this.currentPage, per_page: this.perPage }
                });
                this.users = response.data.data;
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
                this.perPage = response.data.per_page;
                this.lastPage = response.data.last_page;
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                this.loading = false;
            }
        },
        applyFilter() {
            this.loading = true;
            axios.get("brand", { params: { search: this.filter } })
                .then((response) => {
                    this.users = response.data.data;
                    this.total = response.data.total;
                    this.currentPage = response.data.current_page;
                })
                .catch((error) => console.error("Error applying filter:", error))
                .finally(() => { this.loading = false; });
        },
        pageChanged(newPage) {
            this.currentPage = newPage;
            this.fetchData();
        },
        async toggleReorder() {
            if (this.reorderMode) {
                this.reorderMode = false;
                this.reorderList = [];
                return;
            }
            this.loading = true;
            try {
                const response = await axios.get("brandforExport");
                this.reorderList = response.data.data;
                this.reorderMode = true;
            } catch (error) {
                console.error("Error loading all brands for reorder:", error);
            } finally {
                this.loading = false;
            }
        },
        onDragEnd() {},
        async saveOrder() {
            this.savingOrder = true;
            try {
                const ids = this.reorderList.map(item => item.id);
                await axios.post("brandReorder", { ids });
                this.$bvToast.toast("Brand order saved successfully!", {
                    title: "Success", variant: "primary", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 3000,
                });
                this.reorderMode = false;
                this.reorderList = [];
                this.fetchData();
            } catch (error) {
                console.error("Error saving order:", error);
                this.$bvToast.toast("Error saving brand order!", {
                    title: "Error", variant: "danger", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 5000,
                });
            } finally {
                this.savingOrder = false;
            }
        },
        exportAllDataToCSV() {
            this.fetchAllParents((allParents) => {
                const csv = Papa.unparse(allParents);
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "exported_data.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        fetchAllParents(callback) {
            axios.get("brandforExport", { params: { per_page: this.totalRows } })
                .then((response) => callback(response.data.data))
                .catch((error) => console.error("Error fetching all Data:", error));
        },
        editUser(userId) {
            this.$router.push({ name: "EditBrand", params: { id: userId } });
        },
        showDrivers(userId) {
            this.$router.push({ name: "ViewBrand", params: { id: userId } });
        },
        showDeleteConfirmation(itemId) {
            this.itemIdToDelete = itemId;
            this.showDeleteConfirmations = true;
        },
        deleteItem(itemId) {
            this.itemIdToDelete = itemId;
            axios.delete(`brandDelete/${itemId}`)
                .then(() => {
                    this.showDeleteConfirmations = false;
                    this.fetchData();
                })
                .catch((error) => console.error("Error deleting item:", error));
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleDateString();
        },
    },
};
</script>
<style>
.custom-zebra tbody tr:nth-of-type(odd) {
  background-color: #f0f2f5;
}
.custom-zebra tbody tr:hover {
  background-color: #e0e4ea !important;
}
.reorder-row {
  background: #fff;
  transition: background 0.2s;
}
.reorder-row:hover {
  background: #f0f2f5;
}
.drag-handle:hover {
  color: #2f855a;
}
</style>
